<template lang="html">
  <article class="wcc select" :class="{active: boundData.isActive}" v-hammer:tap="makeActive">
    <div class="wcc field">
      <span class="wcc label">{{label}}</span><span class="wcc value" :class="boundData.type">{{numberWithCommas(boundData.value)}}</span>
    </div>
  </article>
</template>
<script>
  export default {
    props: [
      'label',
      'boundData'
    ],
    methods: {
      makeActive($event) {
        this.$store.dispatch('appInput/bindInput', this.boundData)
        if (this.$platform.os.family == 'iOS' || this.$platform.os.family == 'Android') {
          this.$scrollTo($event.target)
        }
      }
    }
  }
</script>
<style lang="scss">
  .wcc.select {
    cursor: pointer;
    transition-duration: $transition-duration;
    // stops the div from collapsing?
    overflow: hidden;
    @media (hover: hover) {
      &:hover {
        color: $blue-400;
      }
    }
    .wcc.field {
      margin: $spacing;
      display: flex;
      justify-content: space-between;
      .wcc.value {
        &.percent {
          &:after {
            content: ' %'
          }
        }
        &.dollar {
          &:before {
            content: '$ '
          }
        }
      }
    }
    &.active {

      box-shadow: 0 0 0 2px #fff inset, 0 0 0 .25em $blue-100 inset;
      background-color: lighten($blue-100, 10%);
      .wcc.field {
        .wcc.label {
          display: none;
        }
        justify-content: center;
        .wcc.value {
          border-right: .15em solid $blue-200;
          animation-name: blink-border;
          animation-duration: 1.5s;
          animation-iteration-count: infinite;
          padding-right: .15em;
          &.percent:after {
            // to keep the element from collapsing
            content: ' ';
            height: 100%;
            margin-right: -1px;
            border-left: 1px solid transparent;
          }
        }
      }
    }
  }
</style>